var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetricTotalItManagersIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85527,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    fill: "#E1EAF9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85527,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    stroke: "#F7F9FD",
    strokeWidth: 3.71054
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5322 20.3366L21.021 20.5897C19.8237 20.5897 18.4975 22.6093 18.2529 23.7334H11.6371C9.5448 23.7334 8.36892 21.4964 10.1103 20.3366C11.6723 19.2963 13.5482 18.69 15.5657 18.69C17.5832 18.69 19.459 19.2963 21.021 20.3366C21.4032 20.5911 20.5734 20.0134 20.6957 20.3366H20.5322Z",
    fill: "#C6D8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.526 23.7334H11.6371C9.5448 23.7334 8.36892 21.4964 10.1103 20.3366C11.6723 19.2963 13.5482 18.69 15.5657 18.69C17.5832 18.69 19.459 19.2963 21.021 20.3366",
    stroke: "#4475CD",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.568 16.6733C17.8464 16.6733 19.128 15.3917 19.128 13.1133C19.128 10.8349 17.8464 9.55325 15.568 9.55325C13.2895 9.55325 12.0079 10.8349 12.0079 13.1133C12.0079 15.3917 13.2895 16.6733 15.568 16.6733Z",
    fill: "#C6D8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6629 16.9985C20.8178 17.0135 20.9787 17.0211 21.1455 17.0211C23.2138 17.0211 24.3772 15.8577 24.3772 13.7895C24.3772 11.815 23.3169 10.6652 21.4212 10.565",
    stroke: "#4475CD",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6629 16.9985C20.8178 17.0135 20.9787 17.0211 21.1455 17.0211C23.2138 17.0211 24.3772 15.8577 24.3772 13.7895C24.3772 11.815 23.3169 10.6652 21.4212 10.565",
    stroke: "#4475CD",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5678 16.3876C17.8463 16.3876 19.1279 15.106 19.1279 12.8276C19.1279 10.5492 17.8463 9.26755 15.5678 9.26755C13.2894 9.26755 12.0078 10.5492 12.0078 12.8276C12.0078 15.106 13.2894 16.3876 15.5678 16.3876Z",
    stroke: "#4475CD",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8462 24.629C24.8461 24.6524 24.854 24.675 24.8684 24.6933L25.1761 25.0809C25.2317 25.1506 25.2651 25.2353 25.2718 25.3243C25.2785 25.4132 25.2582 25.5021 25.2135 25.5793L25.0331 25.8915C24.9887 25.9688 24.9219 26.0308 24.8416 26.0696C24.7612 26.1083 24.6711 26.1219 24.583 26.1085L24.0928 26.034C24.0696 26.0307 24.046 26.0352 24.0257 26.0468L23.4449 26.3821C23.4247 26.3939 23.409 26.4122 23.4004 26.434L23.2196 26.8953C23.1872 26.9782 23.1306 27.0495 23.0571 27.0997C22.9836 27.15 22.8967 27.1769 22.8077 27.1771H22.4469C22.3579 27.1769 22.2709 27.15 22.1974 27.0997C22.124 27.0495 22.0673 26.9782 22.0349 26.8953L21.8541 26.434C21.8455 26.4122 21.8298 26.3939 21.8096 26.3821L21.2289 26.0468C21.2085 26.0352 21.1849 26.0307 21.1617 26.034L20.6716 26.1085C20.5834 26.1219 20.4933 26.1083 20.4129 26.0696C20.3326 26.0308 20.2659 25.9688 20.2214 25.8915L20.0409 25.5793C19.9963 25.5021 19.9761 25.4132 19.9827 25.3243C19.9894 25.2353 20.0228 25.1506 20.0784 25.0809L20.3878 24.6933C20.4022 24.675 20.4101 24.6524 20.41 24.629V23.9585C20.4101 23.9351 20.4022 23.9125 20.3878 23.8942L20.0784 23.5066C20.0228 23.437 19.9894 23.3521 19.9827 23.2632C19.9761 23.1743 19.9963 23.0854 20.0409 23.0082L20.2214 22.696C20.2659 22.6187 20.3326 22.5567 20.4129 22.5179C20.4933 22.4792 20.5834 22.4656 20.6716 22.4789L21.1605 22.5535C21.1837 22.5568 21.2073 22.5523 21.2276 22.5407L21.8096 22.2038C21.8298 22.1919 21.8455 22.1736 21.8541 22.1519L22.0358 21.6922C22.0682 21.6093 22.1248 21.538 22.1983 21.4878C22.2718 21.4375 22.3587 21.4106 22.4477 21.4105H22.8093C22.8983 21.4106 22.9853 21.4375 23.0588 21.4878C23.1322 21.538 23.1888 21.6093 23.2212 21.6922L23.402 22.1519C23.4104 22.1743 23.426 22.1931 23.4465 22.2054L24.0273 22.5407C24.0476 22.5522 24.0713 22.5567 24.0945 22.5535L24.5846 22.4789C24.6728 22.4656 24.7629 22.4792 24.8432 22.5179C24.9236 22.5567 24.9903 22.6187 25.0348 22.696L25.2152 23.0082C25.2599 23.0854 25.2802 23.1743 25.2734 23.2632C25.2667 23.3521 25.2334 23.437 25.1777 23.5066L24.8684 23.8942C24.854 23.9125 24.8461 23.9351 24.8462 23.9585V24.629Z",
    stroke: "#4475CD",
    strokeWidth: 0.882199,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6282 23.8526C22.5167 23.8525 22.4051 23.885 22.3273 23.9501C22.1536 24.0953 22.1427 24.427 22.287 24.5966C22.3653 24.6887 22.4968 24.7348 22.6282 24.7347",
    stroke: "#4475CD",
    strokeWidth: 0.882199,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6279 23.8525C22.7394 23.8524 22.851 23.8849 22.9288 23.95C23.1025 24.0952 23.1135 24.427 22.9691 24.5965C22.8908 24.6886 22.7593 24.7347 22.6279 24.7346",
    stroke: "#4475CD",
    strokeWidth: 0.882199,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricTotalItManagersIcon);
export default __webpack_public_path__ + "static/media/metric_total_it_managers_icon.8430c46888272bcc357324daecbdb19a.svg";
export { ForwardRef as ReactComponent };